<div class="modal-header justify-content-between p-3">
  <h5 class="modal-title text-capitalize d-flex align-items-center gap-2">
    {{ data.projectName }}
    <span class="chat-reset cursor-pointer" title="New Chat" *ngIf="chatHistory.length > 0" (click)="createNewChat()">
      <img src="../../../assets/Krid/img/refresh-chat.svg" alt="Refresh Chat" />
    </span>
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
</div>

<!-- <div class="d-flex justify-content-between align-items-center modal-header">
  <h2 class="project-title d-flex align-items-center gap-2 px-2 pb-0">
    {{ data.projectName }}
    <span class="chat-title" (click)="newSession()">
      <img src="../../../assets/Krid/img/refresh-chat.svg" alt="Refresh Chat" />
    </span>
  </h2>
  <button type="button" class="btn-close me-2" aria-label="Close" (click)="closeDialog()"></button>
</div> -->

<div class="chat-container" >
  <div class="chat-messages">
    <div class="chat-content inner" #chatBoxInner>
      <div class="d-flex">
        <img src="../../../assets/Krid/img/chat-gpt-icon.jpg" class="ai-image me-1" alt="asda" srcset="">
        <div class="ai-message  " >
          <p class="ai-text"><span>Hello! Is there any question related to the project description that I can assist you with? </span></p>
        </div>
      </div>

        <div *ngFor="let message of chatHistory; trackBy: trackByIndex">

          <!-- User message -->
           <div class="d-flex" *ngIf="message.question">

            <div class="user-message d-flex" *ngIf="message.question">


              <p class="user-text">{{ message.question }}</p>
            </div>
            <img [src]="userImage ? userImage : '../../../assets/img/default-user-profile.svg'"alt="Profile Picture" class="ai-image ms-1" (error)="handleImageError()" />
           </div>


          <!-- AI response -->
           <div class="d-flex" *ngIf="message.answer">
             <img src="../../../assets/Krid/img/chat-gpt-icon.jpg" class="ai-image me-1" alt="asda" srcset="">
             <div class="ai-message  d-flex" *ngIf="message.answer">
               <p class="ai-text"><span [innerHTML]="message.answer"></span></p>
             </div>
           </div>
        </div>
    </div>
  </div>
</div>
<div class="chat-input p-3">
  <mat-form-field>
    <textarea matInput [(ngModel)]="userInput" placeholder="Type your message..." rows="3"
      (keyup.enter)="sendMessage()"></textarea>
    <button mat-raised-button color="primary" type="submit" (click)="sendMessage()">
      <i class="fa-solid fa-arrow-up"></i>
    </button>
  </mat-form-field>
</div>


<!-- <div class="chat-actions">
  <button mat-button color="primary" (click)="sendMessage()">Send</button>
  <button mat-button (click)="closeDialog()">Close</button>
</div> -->